import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';

/**
 * Page additional fields
 */

ICmsContentService.registerPageMetaPatch(pageMeta => {
    const additional = 'Additional Configuration';

    if (!pageMeta.fields) {
        pageMeta.fields = [];
    }
    pageMeta.fields.push(
        {
            type: NICmsContentField.EFieldType.label,
            key: 'klevu-header',
            title: 'Klevu',
            tab: additional
        },
        {
            key: 'index_in_klevu',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Index in Klevu',
            default: true,
            tab: additional
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'epsilon-header',
            title: 'Epsilon',
            tab: additional
        },
        {
            key: 'epsilon_page_type',
            type: NICmsContentField.EFieldType.text,
            title: 'Epsilon page type',
            tab: additional
        },
        {
            key: 'additional.hideZendesk',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide Zendesk',
            default: false,
            tab: additional
        }
    );
});
